var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.182 21.3975C26.1626 20.3433 24.2554 18.7574 24.2554 13.5625C24.2554 9.6168 21.381 6.4582 17.5053 5.68328V4.625C17.5053 3.7277 16.7498 3 15.818 3C14.8863 3 14.1308 3.7277 14.1308 4.625V5.68328C10.2551 6.4582 7.38071 9.6168 7.38071 13.5625C7.38071 18.7574 5.47344 20.3433 4.45412 21.3975C4.13757 21.7251 3.99723 22.1166 3.99986 22.5C4.00567 23.3328 4.68468 24.125 5.69345 24.125H25.9426C26.9514 24.125 27.6309 23.3328 27.6362 22.5C27.6389 22.1166 27.4985 21.7246 27.182 21.3975ZM7.56273 21.6875C8.68229 20.2671 9.90632 17.9129 9.91212 13.592C9.91212 13.5818 9.90895 13.5727 9.90895 13.5625C9.90895 10.4212 12.5543 7.875 15.818 7.875C19.0818 7.875 21.7271 10.4212 21.7271 13.5625C21.7271 13.5727 21.724 13.5818 21.724 13.592C21.7298 17.9134 22.9538 20.2677 24.0734 21.6875H7.56273ZM15.818 29C17.6815 29 19.1931 27.5451 19.1931 25.75H12.443C12.443 27.5451 13.9546 29 15.818 29Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6364,
    height: 26,
    fill: "currentColor",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.1aae91f89c029ff97e95b10f9781abb8.svg";
export { ForwardRef as ReactComponent };